import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import PublicApp from "./PublicApp";
import Login from "./Login";
import "./App.css";
import "./PublicApp.css";


const rootElement = document.getElementById("root");
const page = rootElement?.dataset.page;

let ComponentToRender;

switch (page) {
  case "login":
    ComponentToRender = Login;
    break;
  case "premium":
    ComponentToRender = App;
    break;
  default:
    ComponentToRender = PublicApp;
    break;
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ComponentToRender/>
  </React.StrictMode>
);